import { useCallback, useEffect, useState } from "react";
import { getMyUnreadCount } from "@/api/support";
import { useAuth } from "@/context/AuthContext";

// Polls the reporter's unread-reply count for the floating-button badge.
// No-ops (and reports 0) when signed out.
export default function useSupportUnread(pollMs = 30000) {
  const { isAuthenticated } = useAuth();
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!isAuthenticated) {
      setCount(0);
      return;
    }
    try {
      const data = await getMyUnreadCount();
      setCount(data?.count || 0);
    } catch {
      /* keep last known count on transient errors */
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (!isAuthenticated) return undefined;
    refresh();
    const id = setInterval(refresh, pollMs);
    return () => clearInterval(id);
  }, [refresh, pollMs, isAuthenticated]);

  return { count, refresh };
}
